import { _ as _defineProperty } from '../_chunks/dep-27452b12.js';
import { forwardRef, createElement } from 'react';
import { IconBase } from '../icon.js';
import '../style/css.js';
import '../util/use-size-props.js';
import '../util/use-common-classname.js';
import '../util/use-config.js';
import '../util/config-context.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var element = {
  "tag": "svg",
  "attrs": {
    "fill": "none",
    "viewBox": "0 0 24 24",
    "width": "1em",
    "height": "1em"
  },
  "children": [{
    "tag": "circle",
    "attrs": {
      "cx": 12,
      "cy": 12,
      "r": 10,
      "fill": "currentColor"
    }
  }, {
    "tag": "path",
    "attrs": {
      "fill": "#fff",
      "d": "M15.1 9.64c0 .5-.13.94-.4 1.33-.26.39-.61.7-1.06.91.52.22.93.55 1.23.98.3.43.46.91.46 1.45 0 .86-.3 1.55-.87 2.06-.58.51-1.35.77-2.3.77-.95 0-1.72-.26-2.3-.77A2.63 2.63 0 019 14.31c0-.53.15-1.02.44-1.45.3-.44.7-.76 1.22-.99a2.6 2.6 0 01-1.04-.9 2.34 2.34 0 01-.39-1.33c0-.83.27-1.5.8-2 .55-.48 1.26-.73 2.13-.73.88 0 1.59.25 2.12.74.55.5.82 1.16.82 2zm-1.03 4.65c0-.56-.18-1.01-.54-1.36a1.87 1.87 0 00-1.38-.53c-.57 0-1.03.17-1.37.52-.34.35-.52.8-.52 1.37 0 .56.17 1 .5 1.33.34.32.8.48 1.4.48.6 0 1.06-.16 1.4-.48.34-.33.5-.77.5-1.33zm-1.9-6.34c-.5 0-.9.15-1.21.46-.31.3-.46.73-.46 1.26 0 .5.15.91.45 1.23.3.3.7.46 1.21.46s.91-.15 1.21-.46c.31-.32.46-.73.46-1.23 0-.51-.15-.92-.47-1.24a1.6 1.6 0 00-1.2-.48z"
    }
  }]
};
var NumEightIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(IconBase, _objectSpread(_objectSpread({}, props), {}, {
    id: "num-eight",
    ref: ref,
    icon: element
  }));
});
NumEightIcon.displayName = "NumEightIcon";

export { NumEightIcon as default };
//# sourceMappingURL=num-eight.js.map
